import { Storage } from './Storage';
// 获取 token 的函数
export function getToken() {
    let token = Storage.get(Storage.TOKEN_KEY);

    if (!token) {
        // 如果获取 token 失败，返回一个 rejected 的 Promise，设置 HTTP 状态码为 401
        return '';
    }
    return token;
}
